import { render, staticRenderFns } from "./tokenTab.vue?vue&type=template&id=2e00e196&scoped=true&"
import script from "./tokenTab.vue?vue&type=script&lang=js&"
export * from "./tokenTab.vue?vue&type=script&lang=js&"
import style0 from "./tokenTab.vue?vue&type=style&index=0&id=2e00e196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e00e196",
  null
  
)

export default component.exports